import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { Video } from "@/libraries/design/components/video/src/video";
import { wacToken } from "@/libraries/design/foundations";

export const AiFocusVideo = () => (
    <div css={videoContainerStyles}>
        <svg
            css={svgStyles}
            width="1165"
            height="330"
            viewBox="0 0 1165 330"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
        >
            <path
                d="M977.378 10.7676L977.217 24.9795L1150.09 15.0615L1164.88 273.931L204.614 329.028L201.528 275.049L0 272.822L3.0791 0L977.378 10.7676Z"
                fill="#1868DB"
            />
        </svg>

        <div css={videoInnerStyles} className="video-inner">
            <Video
                loop={true}
                playPauseButtonPosition="bottom-left"
                poster="https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MPH2.jpg"
                src="https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNDY.mp4"
            />
        </div>
    </div>
);
const videoContainerStyles = css({
    position: "relative",
    width: "1164px",
    maxWidth: "100%",
    margin: "0 auto 50px",
    minHeight: "330px",
    [media.below.lg]: {
        margin: "0 auto 20px"
    }
});

const videoInnerStyles = css({
    lineHeight: 0,
    padding: "0 100px 100px",
    aspectRatio: "641/337",
    width: "100%",
    [media.below.md]: {
        padding: "0 50px 70px"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    video: {
        width: "100%",
        height: "auto",
        borderStyle: "solid",
        background: wacToken("color.neutral.light0"),
        borderColor: wacToken("color.neutral.light200"),
        borderWidth: "2px",
        borderRadius: "15px"
    }
});

const svgStyles = css({
    position: "absolute",
    insetBlockEnd: 0,
    insetInline: 0,
    width: "100%",
    height: "330px",
    [media.below.lg]: {
        height: "200px"
    }
});
